import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../utils/firebase";
import { Link } from "react-router-dom";

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      const querySnapshot = await getDocs(collection(db, "blogs"));
      const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const publishedBlogs = data.filter((b) => b.published);
      setBlogs(publishedBlogs.sort((a, b) => new Date(b.date) - new Date(a.date)));
    };
    fetchBlogs();
  }, []);

  return (
    <div className="max-w-7xl mx-auto py-16 px-6 min-h-screen">
      <h1 className="text-4xl font-extrabold mb-10 text-center text-[#6cbb23]">
        Zafflo Blogs
      </h1>

      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
        {blogs.map((blog) => (
          <Link
            key={blog.id}
            to={`/blogs/${blog.id}`}
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 duration-300 border border-gray-100"
          >
            <img
              src={blog.coverImage}
              alt={blog.title}
              className="rounded-t-2xl h-48 w-full object-cover"
            />
            <div className="p-5 flex flex-col">
              <h2 className="text-xl font-semibold mb-2 text-gray-800 hover:text-[#6cbb23] transition-colors duration-200">
                {blog.title}
              </h2>
              <p className="text-gray-600 text-sm mb-3 flex-grow">
                {blog.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-gray-500 mt-auto">
                <span>{new Date(blog.date).toDateString()}</span>
                <span className="bg-[#6cbb23]/10 text-[#6cbb23] px-2 py-1 rounded-full text-[11px] font-medium">
                  {blog.author || "Zafflo Team"}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {blogs.length === 0 && (
        <p className="text-center text-gray-500 mt-16">No blogs published yet.</p>
      )}
    </div>
  );
}
